import React from 'react';
import { GUEST_VIEW_OPTIONS, guestViewOptionsFor, withGuestViewDefaults } from '../../../lib/events/foundation';
import './eventsFoundation.css';

// P5: what this event's guests can see. The guest page's server function applies it, so hidden details never reach a guest's browser.
export default function GuestVisibilityChecklist({ value, onChange, plusOnesEnabled, transportMode, disabled = false }) {
    const seen = withGuestViewDefaults(value);
    const shown = guestViewOptionsFor({ plus_ones_enabled: plusOnesEnabled, guest_transport_mode: transportMode });
    return (
        <fieldset className="ef-visibility" data-testid="guest-visibility">
            <legend className="ef-legend ef-small">What guests can see</legend>
            <div className="ef-visibility__list">
                {GUEST_VIEW_OPTIONS.filter((o) => shown.includes(o.key)).map((o) => (
                    <label key={o.key} className="ef-inline"><input type="checkbox" checked={seen[o.key]} disabled={disabled} onChange={(e) => onChange({ ...seen, [o.key]: e.target.checked })} data-testid={`guest-view-${o.key}`} />{o.label}</label>
                ))}
            </div>
        </fieldset>
    );
}
